<template>
  <list tipo="4" icon="recent_actors" titulo_page="Funções"></list>
</template>
<script>
import list from "./List";
export default {
  components: {
    list: list
  }
};
</script>